import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import * as Styled from './AskVeloButton.styles';

const AskVeloButton = ({
  to, href, clickstreamProps, messageId, ...props
}) => {
  // Priority: href takes precedence over to
  let linkProp = null;
  if (href) {
    linkProp = { href };
  } else if (to) {
    linkProp = { to };
  }
  return (
    <Styled.ButtonWrapper>
      <Styled.AskVeloButton
        {...linkProp}
        clickstreamProps={clickstreamProps}
        {...props}
      >
        <FormattedMessage id={messageId} />
      </Styled.AskVeloButton>
    </Styled.ButtonWrapper>
  );
};

AskVeloButton.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  clickstreamProps: PropTypes.shape({
    elementName: PropTypes.string
  }),
  messageId: PropTypes.string
};

AskVeloButton.defaultProps = {
  messageId: 'dashboard.carousel.card.askVelo.button'
};

export default AskVeloButton;
